"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var Modal_1 = tslib_1.__importDefault(require("../../Modal"));
var ControlDots_1 = tslib_1.__importDefault(require("../ControlDots"));
var Footer = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsxs)("div", tslib_1.__assign({}, rest, { children: [(0, jsx_runtime_1.jsx)(ControlDots_1.default, {}), (0, jsx_runtime_1.jsx)(Modal_1.default.Footer, { children: children })] })));
};
exports.default = (0, houston_styles_1.default)(Footer, { label: 'hst-showcase-footer' })(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    background-color: ", ";\n    position: sticky;\n    bottom: 0;\n    width: 100%;\n  "], ["\n    background-color: ", ";\n    position: sticky;\n    bottom: 0;\n    width: 100%;\n  "])), theme.neutralColor.high.pure);
});
var templateObject_1, templateObject_2;
